// extracted by mini-css-extract-plugin
export default {"title":"styles_title__T4-66","desc":"styles_desc__skqDj","input":"styles_input__3P20s"};